import React from 'react';
import PropTypes from 'prop-types';
import { Grid, FormControlLabel, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Autocomplete } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import FormulaField from 'features/common/components/formula-field';
import { FormulaFieldContainer, FormulaFieldLabel } from 'components/common/Styles';

const EngineScoringKnockoutCriteriaListItemComponent = ({
  criterion,
  dictionaryKnockoutCriteria,
  dispatch,
  index,
  isReadOnly,
  collectionValidation
}) => {
  const { t } = useTranslation();
  const onPropertyChanged = (property, propertyValue) => {
    dispatch({
      type: 'OnEngineScoringKnockoutCriterionPropertyChanged',
      property,
      propertyValue,
      index
    });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <Autocomplete
          fullWidth
          value={criterion.criteriaId}
          simpleValue
          options={dictionaryKnockoutCriteria}
          onChange={event => onPropertyChanged('criteriaId', event)}
          label={t('EngineScoring.EngineScoringKnockoutCriteria.Criterion')}
          isDisabled={isReadOnly}
          error={!isValid(collectionValidation[index].criteriaId)}
          helperText={getErrors(collectionValidation[index].criteriaId)}
        />
      </Grid>
      <FormControlLabel
        control={
          <Checkbox
            checked={Boolean(criterion.manualYN)}
            onChange={event => onPropertyChanged('manualYN', event.target.checked)}
            disabled={isReadOnly}
          />
        }
        label={t('EngineScoring.EngineScoringKnockoutCriteria.ManualYN')}
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={Boolean(criterion.preScoring)}
            onChange={event => onPropertyChanged('preScoring', event.target.checked)}
            disabled={isReadOnly}
          />
        }
        label={t('EngineScoring.EngineScoringKnockoutCriteria.PreScoring')}
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={Boolean(criterion.postScoring)}
            onChange={event => onPropertyChanged('postScoring', event.target.checked)}
            disabled={isReadOnly}
          />
        }
        label={t('EngineScoring.EngineScoringKnockoutCriteria.PostScoring')}
      />

      <Grid item xs={12} sm={12}>
        <FormulaFieldLabel>{t('EngineScoring.EngineScoringKnockoutCriteria.AplicabilityFormula')}</FormulaFieldLabel>
        <FormulaFieldContainer>
          <FormulaField
            value={criterion.aplicabilityFormula}
            disabled={isReadOnly}
            onChange={event => onPropertyChanged('aplicabilityFormula', event)}
          />
        </FormulaFieldContainer>
      </Grid>
      <Grid item xs={12} sm={12}>
        <FormulaFieldLabel>{t('EngineScoring.EngineScoringKnockoutCriteria.TitleFormula')}</FormulaFieldLabel>
        <FormulaFieldContainer>
          <FormulaField value={criterion.titleFormula} disabled={isReadOnly} onChange={value => onPropertyChanged('titleFormula', value)} />
        </FormulaFieldContainer>
      </Grid>
      <Grid item xs={12} sm={12}>
        <FormulaFieldLabel>{t('EngineScoring.EngineScoringKnockoutCriteria.ResultFormula')}</FormulaFieldLabel>
        <FormulaFieldContainer>
          <FormulaField
            value={criterion.resultFormula}
            disabled={isReadOnly}
            onChange={event => onPropertyChanged('resultFormula', event)}
          />
        </FormulaFieldContainer>
      </Grid>
    </Grid>
  );
};

EngineScoringKnockoutCriteriaListItemComponent.propTypes = {
  criterion: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  dictionaryKnockoutCriteria: PropTypes.array,
  isReadOnly: PropTypes.bool,
  collectionValidation: PropTypes.object.isRequired
};
export default EngineScoringKnockoutCriteriaListItemComponent;
